<template>
    <section :class="{'border_top': border  }" class="detail-section">
        <div class="detail-section-hd" v-if="title || $slots.title || $slots.main || $slots.extra">
            <div class="detail-section-hd-left">
                <span v-if="title">{{title}}</span>
                <slot name="title"/>
            </div>
            <div class="detail-section-hd-main">
                <slot name="main"/>
            </div>
            <div class="detail-section-hd-right">
                <slot name="extra"/>
                <a v-if="collapsable"  href="javascript:;" class="collapser el-icon-arrow-up" :class="{'is-collapsed': collapsed}" @click="collapsed = !collapsed"></a>
            </div>
        </div>
         <el-collapse-transition>
            <div class="detail-section-content" v-show="!collapsable || !collapsed" >
                <div :style="contentStyle">
                    <slot />
                </div>
            </div>
         </el-collapse-transition>
    </section>
</template>

<script>
export default {
    name: 'v-detail-section',
    props: {
        title: String,
        contentStyle: {
            type: [String, Object],
            default () {
                return {
                    padding: '18px'
                }
            }
        },
        border: {
            type: Boolean,
            default: false
        },
        collapsable: {
            type: Boolean,
            default: true
        },
        defaultCollapsed: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            collapsed: false
        }
    },
    watch: {
        defaultCollapsed:  {
           immediate: true,
           handler ()  {
               this.collapsed = this.defaultCollapsed
           }
        }
    }
}
</script>

<style lang="less">
.detail-section {
    &-hd {
        background:rgba(243,243,243, 0.6);
        padding: 6px 20px;
        font-size: 18px;
        margin-bottom: 0;
        color: #606060;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    &.border_top {
        border-top: 1px solid #D7D7D7;
    }
    .collapser {
        text-decoration: none;
        font-size: 20px;
        color: #606060;
        display: inline-block;
        transition: transform .3s;
        &.is-collapsed {
            transform: rotate(180deg);
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/framework/detail/section.vue